import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useState, useEffect, useContext } from "react";
import ScorecardFiltersViewModel from "../../Viewmodels/ScorecardFiltersViewModel";
import { APIContext } from "../../../Contexts/APIContext";
import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';

interface IChannelFiltersDialogProps {
    open: boolean;
    setOpen: (isOpen: boolean) => void;
    client: string;
    currentChannel: string;
    changeFilter: (filterName: keyof ScorecardFiltersViewModel, newValue: any) => void;
}

export default function ChannelFiltersDialog({ open, setOpen, client, currentChannel, changeFilter }: IChannelFiltersDialogProps) {
    const { get } = useContext(APIContext)
    const [channelList, setChannelList] = useState<string[]>([])
    const [channel, setChannel] = useState(currentChannel)

    useEffect(() => {
        get('Search', `GetChannelsDropDown?client=${client}`, (data) => setChannelList(data))
    }, [client])

    const confirm = () => {
        changeFilter('channel', channel);
        setOpen(false);
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="sm" >
            <DialogTitle>Channel Filters</DialogTitle>
            <DialogContent>
                <Grid container height="100%">
                    <Grid container size={12}>
                        <Grid size={12} >
                            <Select
                                value={channel}
                                onChange={(e) => setChannel(e.target.value as string)}
                                endAdornment={channel &&
                                    <IconButton onClick={() => setChannel('')} sx={{ marginRight: 2 }}>
                                        <ClearIcon />
                                    </IconButton>}
                                fullWidth>
                                {
                                    channelList.map(item =>
                                        <MenuItem key={item} value={item}>{item}</MenuItem>)
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setOpen(false)}>
                    Cancel
                </Button>
                <Button onClick={confirm}>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}